export default "__VITE_PUBLIC_ASSET__a30f5cde__"